/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M168.8 458.124c-10.087 0-19.687-4.403-26.214-12.057L8.315 289.523c-12.416-14.49-10.726-36.301 3.737-48.743 14.515-12.441 36.326-10.726 48.717 3.738l107.8 125.696L438.52 50.265c12.339-14.566 34.124-16.435 48.69-4.122 14.618 12.314 16.461 34.125 4.173 48.717L195.22 445.862c-6.554 7.731-16.154 12.237-26.266 12.262h-.153z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconCheck = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconCheck.defaultProps = {
  theme,
};
IconCheck.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconCheck.displayName = 'IconCheck';
export { IconCheck };
